export function assertNotNullish(value, message) {
    if (value === undefined || value === null) {
        throw new Error(message);
    }
}
export const isNotNullish = (value) => {
    return value !== undefined && value !== null;
};
//# sourceMappingURL=types.js.map